import { Product } from "../../../types/Shop";
import { functions } from "../../firebase";
export const createProduct = async (params: { communityId: string; product: Product }): Promise<string> => {
  const result = await functions.httpsCallable("saveShopProduct")(params);
  return result.data.productId;
};
